import React from 'react';
import { Button, Input, InputNumber, Select } from 'antd';

export function buildNavBarTab(context) {
  const { shouldShowPage, handleSaveSystemSettings, updateSystemSettings, systemSettings } = context;
  if (!shouldShowPage('导航栏设置')) return null;
  if (!systemSettings?.navigationBar) return null;

  return {
    key: 'nav_bar',
    label: '导航栏设置',
    children: (
      <div>
        <h3>导航栏设置</h3>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={handleSaveSystemSettings}>保存设置</Button>
          <Button style={{ marginLeft: 8 }} onClick={() => {
            updateSystemSettings(settings => ({
              ...settings,
              navigationBar: {
                height: 32,
                backgroundColor: '#4176a7',
                textColor: '#ffffff',
                fontSize: 16,
                linkSpacing: 32,
                linkPadding: 16,
                show: true
              },
              mobileNavigationBar: {
                height: 76,
                backgroundColor: '#4176a7',
                textColor: '#ffffff',
                fontSize: 14,
                linkSpacing: 16,
                linkPadding: 8,
                show: true,
                firstRowHeight: 40,
                secondRowHeight: 36,
                secondRowFontSize: 12,
                announcementFontSize: 12,
                announcementColor: '#ffffff',
                buttonFontSize: 12,
                buttonHeight: 24,
                buttonPadding: '4px 8px'
              }
            }));
          }}>重置默认</Button>
        </div>

        <div style={{ marginBottom: 24 }}>
          <h4 style={{ color: '#1890ff', borderBottom: '2px solid #1890ff', paddingBottom: 8 }}>PC端设置</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <h4>导航栏高度 (像素)</h4>
              <InputNumber
                value={systemSettings.navigationBar.height}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  navigationBar: { ...settings.navigationBar, height: value }
                }))}
                min={16}
                max={120}
                style={{ width: '100%' }}
              />
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>独立于标题栏，可单独调节</div>
            </div>
            <div>
              <h4>字体大小 (像素)</h4>
              <InputNumber
                value={systemSettings.navigationBar.fontSize}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  navigationBar: { ...settings.navigationBar, fontSize: value }
                }))}
                min={12}
                max={24}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>链接间距 gap (像素)</h4>
              <InputNumber
                value={systemSettings.navigationBar.linkSpacing}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  navigationBar: { ...settings.navigationBar, linkSpacing: value ?? 0 }
                }))}
                min={0}
                max={80}
                style={{ width: '100%' }}
              />
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>链接之间的空隙，可设为 0</div>
            </div>
            <div>
              <h4>链接左右内边距 (像素)</h4>
              <InputNumber
                value={systemSettings.navigationBar.linkPadding ?? 16}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  navigationBar: { ...settings.navigationBar, linkPadding: value ?? 0 }
                }))}
                min={0}
                max={40}
                style={{ width: '100%' }}
              />
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>想更紧凑请同时调小此项（原先固定 16px）</div>
            </div>
            <div>
              <h4>显示状态</h4>
              <Select
                value={systemSettings.navigationBar.show ? 'show' : 'hide'}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  navigationBar: { ...settings.navigationBar, show: value === 'show' }
                }))}
                style={{ width: '100%' }}
              >
                <Select.Option value="show">显示</Select.Option>
                <Select.Option value="hide">隐藏</Select.Option>
              </Select>
            </div>
            <div>
              <h4>背景颜色</h4>
              <Input
                value={systemSettings.navigationBar.backgroundColor}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  navigationBar: { ...settings.navigationBar, backgroundColor: e.target.value }
                }))}
                placeholder="#4176a7"
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>文字颜色</h4>
              <Input
                value={systemSettings.navigationBar.textColor}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  navigationBar: { ...settings.navigationBar, textColor: e.target.value }
                }))}
                placeholder="#ffffff"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <h4 style={{ color: '#52c41a', borderBottom: '2px solid #52c41a', paddingBottom: 8 }}>手机端设置</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <h4>第一行高度 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.firstRowHeight
                  ?? Math.max(24, (systemSettings.mobileNavigationBar?.height || 76) - (systemSettings.mobileNavigationBar?.secondRowHeight || 36))}
                onChange={value => updateSystemSettings(settings => {
                  const prev = settings.mobileNavigationBar || {};
                  const firstRowHeight = value ?? 40;
                  const secondRowHeight = prev.secondRowHeight ?? 36;
                  return {
                    ...settings,
                    mobileNavigationBar: {
                      ...prev,
                      firstRowHeight,
                      height: firstRowHeight + secondRowHeight
                    }
                  };
                })}
                min={24}
                max={80}
                style={{ width: '100%' }}
              />
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>导航链接行独立高度</div>
            </div>
            <div>
              <h4>导航链接字体大小 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.fontSize || 14}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), fontSize: value }
                }))}
                min={10}
                max={20}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>链接间距 gap (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.linkSpacing ?? 16}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), linkSpacing: value ?? 0 }
                }))}
                min={0}
                max={40}
                style={{ width: '100%' }}
              />
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>可设为 0</div>
            </div>
            <div>
              <h4>链接左右内边距 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.linkPadding ?? 8}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), linkPadding: value ?? 0 }
                }))}
                min={0}
                max={24}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>第二行高度 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.secondRowHeight || 36}
                onChange={value => updateSystemSettings(settings => {
                  const prev = settings.mobileNavigationBar || {};
                  const secondRowHeight = value ?? 36;
                  const firstRowHeight = prev.firstRowHeight
                    ?? Math.max(24, (prev.height || 76) - (prev.secondRowHeight || 36));
                  return {
                    ...settings,
                    mobileNavigationBar: {
                      ...prev,
                      firstRowHeight,
                      secondRowHeight,
                      height: firstRowHeight + secondRowHeight
                    }
                  };
                })}
                min={24}
                max={60}
                style={{ width: '100%' }}
              />
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                总高度自动为 {((systemSettings.mobileNavigationBar?.firstRowHeight
                  ?? Math.max(24, (systemSettings.mobileNavigationBar?.height || 76) - (systemSettings.mobileNavigationBar?.secondRowHeight || 36)))
                  + (systemSettings.mobileNavigationBar?.secondRowHeight || 36))}px
              </div>
            </div>
            <div>
              <h4>第二行字体大小 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.secondRowFontSize || 12}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), secondRowFontSize: value }
                }))}
                min={10}
                max={16}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>公告字体大小 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.announcementFontSize || 12}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), announcementFontSize: value }
                }))}
                min={10}
                max={16}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>公告文字颜色</h4>
              <Input
                value={systemSettings.mobileNavigationBar?.announcementColor || '#ffffff'}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), announcementColor: e.target.value }
                }))}
                placeholder="#ffffff"
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>按钮字体大小 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.buttonFontSize || 12}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), buttonFontSize: value }
                }))}
                min={10}
                max={16}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>按钮高度 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileNavigationBar?.buttonHeight || 24}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), buttonHeight: value }
                }))}
                min={20}
                max={40}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>显示状态</h4>
              <Select
                value={(systemSettings.mobileNavigationBar?.show !== false) ? 'show' : 'hide'}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), show: value === 'show' }
                }))}
                style={{ width: '100%' }}
              >
                <Select.Option value="show">显示</Select.Option>
                <Select.Option value="hide">隐藏</Select.Option>
              </Select>
            </div>
            <div>
              <h4>背景颜色</h4>
              <Input
                value={systemSettings.mobileNavigationBar?.backgroundColor || '#4176a7'}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), backgroundColor: e.target.value }
                }))}
                placeholder="#4176a7"
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>文字颜色</h4>
              <Input
                value={systemSettings.mobileNavigationBar?.textColor || '#ffffff'}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  mobileNavigationBar: { ...(settings.mobileNavigationBar || {}), textColor: e.target.value }
                }))}
                placeholder="#ffffff"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>

        <div style={{ marginTop: 16, padding: 16, border: '1px solid #d9d9d9', borderRadius: 6, backgroundColor: '#fafafa' }}>
          <h4>预览效果</h4>
          <div style={{
            height: `${systemSettings.navigationBar.height}px`,
            backgroundColor: systemSettings.navigationBar.backgroundColor,
            color: systemSettings.navigationBar.textColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            borderRadius: 4,
            marginBottom: 8
          }}>
            <div style={{ display: 'flex', gap: `${systemSettings.navigationBar.linkSpacing ?? 0}px`, fontSize: `${systemSettings.navigationBar.fontSize}px` }}>
              {['首页', '指挥系统', '工具下载'].map((label) => (
                <span key={label} style={{ padding: `0 ${systemSettings.navigationBar.linkPadding ?? 16}px` }}>{label}</span>
              ))}
            </div>
            <div style={{ fontSize: `${systemSettings.navigationBar.fontSize}px` }}>
              <span>欢迎，admin</span>
            </div>
          </div>
          <div style={{ maxWidth: '400px' }}>
            <div style={{
              height: `${systemSettings.mobileNavigationBar?.firstRowHeight
                ?? Math.max(24, (systemSettings.mobileNavigationBar?.height || 76) - (systemSettings.mobileNavigationBar?.secondRowHeight || 36))}px`,
              backgroundColor: systemSettings.mobileNavigationBar?.backgroundColor || '#4176a7',
              color: systemSettings.mobileNavigationBar?.textColor || '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: `${systemSettings.mobileNavigationBar?.linkSpacing ?? 16}px`,
              padding: '0 8px',
              borderRadius: '4px 4px 0 0',
              fontSize: `${systemSettings.mobileNavigationBar?.fontSize || 14}px`
            }}>
              {['首页', '指挥系统', '工具下载'].map((label) => (
                <span key={label} style={{ padding: `0 ${systemSettings.mobileNavigationBar?.linkPadding ?? 8}px` }}>{label}</span>
              ))}
            </div>
            <div style={{
              height: `${systemSettings.mobileNavigationBar?.secondRowHeight || 36}px`,
              backgroundColor: systemSettings.mobileNavigationBar?.backgroundColor || '#4176a7',
              color: systemSettings.mobileNavigationBar?.textColor || '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 12px',
              borderRadius: '0 0 4px 4px',
              fontSize: `${systemSettings.mobileNavigationBar?.secondRowFontSize || 12}px`
            }}>
              <div style={{ fontSize: `${systemSettings.mobileNavigationBar?.announcementFontSize || 12}px` }}>
                📢 公告内容...
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <span>欢迎，admin</span>
                <button style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  color: systemSettings.mobileNavigationBar?.textColor || '#ffffff',
                  padding: systemSettings.mobileNavigationBar?.buttonPadding || '4px 8px',
                  borderRadius: '4px',
                  fontSize: `${systemSettings.mobileNavigationBar?.buttonFontSize || 12}px`,
                  height: `${systemSettings.mobileNavigationBar?.buttonHeight || 24}px`,
                  cursor: 'pointer'
                }}>
                  退出
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  };
}
